const APPT_STATUS_LABELS = {
  completed: 'Done',
  in_treatment: 'In treatment',
  checked_in: 'Checked in',
  arriving: 'Arriving soon',
  scheduled: 'Upcoming',
  late: 'Late',
  no_show: 'No-show',
}

/**
 * @param {{ guests?: { new?: number, returning?: number, vip?: number, birthdays?: number } }} snapshot
 * @returns {{ name: string, value: number, color: string }[]}
 */
export function guestMixChartData(snapshot) {
  const guests = snapshot?.guests ?? {}
  return [
    { name: 'New', value: guests.new ?? 0, color: '#7C3AED' },
    { name: 'Returning', value: guests.returning ?? 0, color: '#10B981' },
    { name: 'VIP', value: guests.vip ?? 0, color: '#D4A373' },
    { name: 'Birthdays', value: guests.birthdays ?? 0, color: '#C084FC' },
  ].filter((row) => row.value > 0)
}

/**
 * @param {{ stats?: { occupied?: number, available?: number, turnover?: number } }} floor
 * @returns {{ name: string, value: number, color: string }[]}
 */
export function floorMixChartData(floor) {
  const stats = floor?.stats ?? {}
  const rows = [
    { name: 'Occupied', value: stats.occupied ?? 0, color: '#7C3AED' },
    { name: 'Available', value: stats.available ?? 0, color: '#10B981' },
    { name: 'Turnover', value: stats.turnover ?? 0, color: '#F59E0B' },
  ]
  const total = rows.reduce((sum, row) => sum + row.value, 0)
  return total > 0 ? rows.filter((row) => row.value > 0) : rows
}

/**
 * @param {{ appointments?: { status?: string }[] }} timeline
 * @returns {{ name: string, value: number, color: string }[]}
 */
export function appointmentMixChartData(timeline) {
  const appointments = Array.isArray(timeline?.appointments) ? timeline.appointments : []
  const counts = {}

  for (const appt of appointments) {
    const key = appt.status ?? 'scheduled'
    counts[key] = (counts[key] ?? 0) + 1
  }

  const colors = {
    completed: '#10B981',
    in_treatment: '#7C3AED',
    checked_in: '#6366F1',
    arriving: '#C084FC',
    scheduled: '#94A3B8',
    late: '#F59E0B',
    no_show: '#F43F5E',
  }

  return Object.entries(counts).map(([status, value]) => ({
    name: APPT_STATUS_LABELS[status] ?? status,
    value,
    color: colors[status] ?? '#94A3B8',
  }))
}

/**
 * @param {{ name: string, value: number }[]} rows
 */
export function chartTotal(rows) {
  return rows.reduce((sum, row) => sum + row.value, 0)
}
